$(function () {
    if ($(".camc-fil-messaging").length > 0) {
        bindEvents();
    }

    function bindEvents() {
        $(".camc-fil-messaging__item").each((i, item) => {
            $(item)
                .find(".close-message")
                .on("click", () => {
                    $(item).hide();
                });
        });
    }
});

window.showApiMessageing = function (domDiv) {
    $(".camc-fil-messaging__item").show();
    if (domDiv && domDiv !== null) {
        domDiv.empty();
        domDiv.append('<div class="api-messaging-level">暂无数据显示</div>');
    }
};
